
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 80 80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"63","cy":"70","r":"8","fill":"#2962FF"}}),_c('g',{attrs:{"filter":"url(#filter0_d_1101_50800)"}},[_c('rect',{attrs:{"x":"17","y":"20","width":"46","height":"38","rx":"4","fill":"white"}}),_c('rect',{attrs:{"x":"25","y":"28","width":"30","height":"4","rx":"2","fill":"#E0E0E0"}}),_c('rect',{attrs:{"x":"25","y":"34","width":"15","height":"4","rx":"2","fill":"#E0E0E0"}}),_c('rect',{attrs:{"x":"25","y":"40","width":"30","height":"4","rx":"2","fill":"#E0E0E0"}}),_c('rect',{attrs:{"x":"25","y":"46","width":"15","height":"4","rx":"2","fill":"#E0E0E0"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1101_50800","x":"9","y":"16","width":"62","height":"54","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","type":"matrix","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"4"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"4"}}),_c('feColorMatrix',{attrs:{"type":"matrix","values":"0 0 0 0 0.34902 0 0 0 0 0.407843 0 0 0 0 0.560784 0 0 0 0.16 0"}}),_c('feBlend',{attrs:{"mode":"normal","in2":"BackgroundImageFix","result":"effect1_dropShadow_1101_50800"}}),_c('feBlend',{attrs:{"mode":"normal","in":"SourceGraphic","in2":"effect1_dropShadow_1101_50800","result":"shape"}})])])])
          )
        }
      }
    